/**
 * The Cortona3D Solo module. The main interface of the Cortona3D Solo API:
 *
 * - Uses the Universal Module Definition (UMD) interface;
 * - Exports {@link Cortona3DSolo} global object;
 * - The exported object is an instance of the {@link external:EventEmitter EventEmitter} class;
 * - Exports namespaces {@link module:solo.core core}, {@link module:solo.app app}.
 *  
 * **Configuration:**
 * ```
 * Cortona3DSolo.use('core');
 * ```
 * See the {@link module:solo.use use()} method for more details.
 * 
 * @module solo
 * @implements {@link external:EventEmitter EventEmitter}
 */

var expand = require('lib/util').expand,
    EventEmitter = require('events').EventEmitter;

var Cortona3DSolo = expand(new EventEmitter(), window.Cortona3DSolo || {});

Cortona3DSolo.setMaxListeners(0); // Infinity

/**
 * @memberof module:solo
 * @member {string} baseUrl The relative base URL of a Cortona3D Solo library.
 * @since 1.4.0
 */

var m_baseUrl = Cortona3DSolo.baseUrl || Cortona3DSolo.baseURL || (document.currentScript && document.currentScript.src.replace(/[^\\\/]+$/, '')) || '';

Object.defineProperty(Cortona3DSolo, 'baseURL', {
    get: function () { return m_baseUrl; },
    set: function (value) { m_baseUrl = value; },
    enumerable: true
});

Object.defineProperty(Cortona3DSolo, 'baseUrl', {
    get: function () { return m_baseUrl; },
    set: function (value) { m_baseUrl = value; },
    enumerable: true
});

/**
 * @memberof module:solo
 * @member {boolean} __trace Allows to track all events in the browser console.
 * @since 1.8.3
 */
Object.defineProperty(Cortona3DSolo, '__trace', {
    value: false,
    writable: true
});


module.exports = Cortona3DSolo;
